// "Aircraft details" card of a charter booking: operator | model + tail | category + seats.
import type { ReactNode } from 'react';
import { Card, Col, Descriptions, Row, Typography } from 'antd';

import type { CharterBookingDetail } from '../../api/types';
import { formatCategory } from '../../data/airportLabel';

const { Text } = Typography;

export function AircraftDetailsCard({
  b,
  extra,
}: {
  b: CharterBookingDetail;
  extra: ReactNode;
}) {
  return (
    <Card
      title="Aircraft details"
      extra={extra}
    >
      <Row gutter={24}>
        <Col xs={24} sm={8}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Operator">{b.operatorName || '—'}</Descriptions.Item>
          </Descriptions>
        </Col>
        <Col xs={24} sm={8}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Model name">{b.modelName || '—'}</Descriptions.Item>
            <Descriptions.Item label="Tail number">{b.tailNumber || '—'}</Descriptions.Item>
          </Descriptions>
        </Col>
        <Col xs={24} sm={8}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Category">{formatCategory(b.category)}</Descriptions.Item>
            <Descriptions.Item label="Seats">{b.seatingCapacity ?? '—'}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      {b.aircraftEdited ? (
        <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
          Edited on this booking. The quote still reads{' '}
          {[b.quotedAircraft.modelName, b.quotedAircraft.tailNumber].filter(Boolean).join(' · ') || '—'}.
        </Text>
      ) : null}
    </Card>
  );
}
